import { Input } from 'src/shared/components/ui/input'
import { TableCell } from 'src/shared/components/ui/table'
import { Badge } from 'src/shared/components/ui/badge'

export const ProductRowDiscountCell = ({
  isEditMode,
  discountLocal,
  onDiscountChange,
  discount,
}: {
  isEditMode: boolean
  discountLocal: number
  onDiscountChange: (value: number) => void
  discount: number
}) => (
  <TableCell className="py-2 px-5 text-sm text-gray-700 align-middle text-center">
    {isEditMode ? (
      <Input
        type="number"
        value={discountLocal}
        onChange={(e) => onDiscountChange(Number(e.target.value) || 0)}
        className="w-20 h-7 text-center text-sm px-1 border-gray-300 mx-auto"
      />
    ) : discount > 0 ? (
      <Badge variant="red">{discount}%</Badge>
    ) : (
      discount.toLocaleString('sv-SE')
    )}
  </TableCell>
)
